import React from 'react';

import styled from 'styled-components';

import { Form, Radio } from 'antd';

import { useImmerAtom } from 'jotai-immer';

import * as Constants from '../../views/diagnosis/constants';

import { kidneyAtom } from './atom';
import { useHandleEventValue } from './hooks';

const Lowsalt = ({ getFieldDecorator, radioButtonMessage }) => {
  const [, setKidney] = useImmerAtom(kidneyAtom);
  const handleChangeValue = useHandleEventValue({ setImmerState: setKidney });

  return (
    <Form.Item>
      {getFieldDecorator('kidneyStatus', {
        rules: [{ required: true, message: radioButtonMessage }]
      })(
        <KidneyStatusSection>
          <QueryTitle>
            식단을 통해 가장 관리하고 싶은 <br /> 질환을 선택해주세요
            <br />
          </QueryTitle>
          <Radio.Group buttonStyle="solid">
            {Constants.KIDNEY_CAUSES.map(item => {
              const { name, value } = item;
              return (
                <SelectBox key={value} onClick={handleChangeValue('causesLowSalt')} value={value}>
                  {name}
                </SelectBox>
              );
            })}
          </Radio.Group>
        </KidneyStatusSection>
      )}
    </Form.Item>
  );
};

export default Lowsalt;

const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;

const KidneyStatusSection = styled(RelayionTypeSection)``;

const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;

const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;
